/*@ngInject*/
const MakeApplicationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.makeApplication = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/makeApplication',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('makeApplicationRepository', MakeApplicationRepository);
